/* LicensedTime cart: quantity, remove, gift option, cross-sell add. Works for the drawer and the /cart page.
   The cart markup comes from snippets/lt-cart-body.liquid through the Section Rendering API. */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const $ = (s, r) => (r || document).querySelector(s);
let selfDispatch = false;

const rootFor = (el) => (el && el.closest ? el.closest('[data-lt-cart-root]') : null);
const sectionId = (root) => (root && root.dataset.ltSection) || 'cart-drawer-section';
const roots = () => Array.from(document.querySelectorAll('[data-lt-cart-root]'));

const post = (url, body) =>
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify(body)
  }).then((r) => r.json());

const message = (root, text) => {
  const m = $('[data-lt-cart-msg]', root);
  if (!m) return;
  m.textContent = text || '';
  m.hidden = !text;
};

/* swap in fresh cart markup without losing scroll, focus or the Shopify express-pay buttons */
const apply = (root, html) => {
  if (!root || !html) return;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const next = $('[data-lt-cart-body]', doc);
  const cur = $('[data-lt-cart-body]', root);
  if (!next || !cur) return;
  const scroller = $('.lt-cart__scroll', cur);
  const top = scroller ? scroller.scrollTop : 0;
  const active = document.activeElement;
  let focusSpec = null;
  if (active && cur.contains(active)) {
    const li = active.closest('.lt-cart__item');
    if (li && active.hasAttribute('data-lt-qty')) {
      focusSpec = { key: li.dataset.key, idx: Array.from(li.querySelectorAll('[data-lt-qty]')).indexOf(active) };
    }
  }
  const express = $('.lt-cart__express', cur);
  const nextExpress = $('.lt-cart__express', next);
  if (express && nextExpress) nextExpress.replaceWith(express); // keep the live buttons, do not re-run their scripts
  cur.replaceWith(next);
  const scroller2 = $('.lt-cart__scroll', next);
  if (scroller2) scroller2.scrollTop = top;
  if (focusSpec) {
    const li = Array.from(next.querySelectorAll('.lt-cart__item')).find((n) => n.dataset.key === focusSpec.key);
    const btn = li && li.querySelectorAll('[data-lt-qty]')[focusSpec.idx];
    if (btn) btn.focus({ preventScroll: true });
  }
  enhance();
};

/* tell the rest of the theme (header cart count) that the cart changed */
const announce = (action, cart, lines) => {
  try {
    const deferred = CartLinesUpdateEvent.createPromise();
    selfDispatch = true;
    document.body.dispatchEvent(new CartLinesUpdateEvent({ action, context: 'cart', lines, promise: deferred.promise }));
    selfDispatch = false;
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'lt-cart', sourceId: 'lt-cart', itemCount: cart.item_count, didError: false } });
  } catch (e) {
    selfDispatch = false;
  }
};

const run = async (root, url, body, action, lines) => {
  root.classList.add('is-busy');
  try {
    const id = sectionId(root);
    const res = await post(url, { ...body, sections: id, sections_url: window.location.pathname });
    if (res.status) {
      message(root, res.description || res.message || 'That could not be updated. Please try again.');
      return;
    }
    apply(root, res.sections && res.sections[id]);
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((r) => r.json());
    announce(action, cart, lines);
  } catch (e) {
    message(root, 'Something went wrong. Please check your connection and try again.');
  } finally {
    root.classList.remove('is-busy');
  }
};

const refresh = async (root) => {
  const id = sectionId(root);
  const res = await fetch(`${window.location.pathname}?sections=${id}`, { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((r) => r.json());
  apply(root, res[id]);
};

/* the empty cart points at the shopper's team when one is set and live */
const enhance = () => {
  const cta = $('[data-lt-empty-cta]');
  if (!cta) return;
  const LT = window.LT;
  const go = () => {
    const my = window.LT && window.LT.getMyTeam && window.LT.getMyTeam();
    if (my && my.live && my.u) {
      cta.href = my.u;
      cta.textContent = `Shop ${my.s}`;
    }
  };
  if (LT && LT.teams) go();
  else document.addEventListener('lt:ready', go, { once: true });
};

/* ---------- events (delegated; the markup is replaced after every change) ---------- */
document.addEventListener('click', (e) => {
  const root = rootFor(e.target);
  if (!root) return;
  if (e.target.closest('[data-lt-cart-close]')) {
    const d = document.getElementById('cart-drawer');
    if (d && typeof d.close === 'function') d.close();
    return;
  }
  const q = e.target.closest('[data-lt-qty]');
  if (q) {
    const li = q.closest('.lt-cart__item');
    const qty = Math.max(0, Number(q.dataset.ltQty));
    message(root, '');
    run(root, '/cart/change.js', { line: Number(li.dataset.line), quantity: qty }, qty === 0 ? 'clear' : 'change', [{ merchandiseId: String(li.dataset.variantId), quantity: qty }]);
    return;
  }
  const add = e.target.closest('[data-lt-add]');
  if (add) {
    add.disabled = true;
    message(root, '');
    run(root, '/cart/add.js', { id: Number(add.dataset.ltAdd), quantity: 1 }, 'add', [{ merchandiseId: String(add.dataset.ltAdd), quantity: 1 }]).finally(() => {
      add.disabled = false;
    });
  }
});

const saveGift = (root) => {
  const on = $('[data-lt-gift]', root).checked;
  const text = on ? $('[data-lt-giftmsg-input]', root).value.slice(0, 200) : '';
  return post('/cart/update.js', { attributes: { Gift: on ? 'Yes' : '', 'Gift message': text } });
};
document.addEventListener('change', (e) => {
  const root = rootFor(e.target);
  if (!root) return;
  if (e.target.matches('[data-lt-gift]')) {
    const box = $('[data-lt-giftmsg]', root);
    box.hidden = !e.target.checked;
    if (e.target.checked) $('[data-lt-giftmsg-input]', root).focus();
    saveGift(root);
  } else if (e.target.matches('[data-lt-giftmsg-input]')) {
    saveGift(root);
  }
});
let giftTimer;
document.addEventListener('input', (e) => {
  const root = rootFor(e.target);
  if (!root || !e.target.matches('[data-lt-giftmsg-input]')) return;
  window.clearTimeout(giftTimer);
  giftTimer = window.setTimeout(() => saveGift(root), 600);
});

/* a product page (or anything else) added to the cart: refresh from its response, or fetch fresh markup */
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (selfDispatch || !event.promise) return;
  event.promise
    .then(({ detail }) => {
      roots().forEach((root) => {
        const html = detail && detail.sections && detail.sections[sectionId(root)];
        if (html) apply(root, html);
        else refresh(root);
      });
    })
    .catch(() => {});
});

enhance();
document.addEventListener('lt:myteam', enhance);
